
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Loading } from './Control';
import { MobileContext } from './Context';
import { classnames, getOverWidth } from './Utils';
import { HAComponent } from './Generic';

/**
 * 避免陷入 circular dependency.
 */
class Forming extends HAComponent {
	static version = '0.1.1';
	static propTypes = {
		submittable: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
		submit: PropTypes.func,
	};
	static defaultProps = {
		submittingText: '送出中 ...',
	};
	state = {
		isSubmitting: false,
	};
	inputs = {};

	constructor(props) {
		super(props);
		const { inputs } = this.props;
		if (inputs) this.inputs = inputs;

		this.validate = this.validate.bind(this);
		this.submittable = this.submittable.bind(this);
		this.submit = this.submit.bind(this);
	}

	reset() {
		_.values(this.inputs).map(input => {
			if (input) input.reset();
		});
		return this;
	}

	validate() {
		const { validate } = this.props;
		return _.reduce(this.inputs, (result, input, idx) => {
			if (!input) return result;
			return input.validate() && result;
		}, true) && (!validate || _.isFunction(validate) && validate());
	}
	submittable() { return true; }
	submit() { }

	getValue(id) {
		const input = this.inputs[id];
		//if (input instanceof J104Picker) input.blur();
		return !input || !input.isEnable() ? undefined : input.getValue();
	}
	getValues() {
		const values = _.mapValues(
			_.pickBy(this.inputs, o => !(o === null || o === undefined || o === Math.NaN || !o.isEnable())),
			input => input.getValue()
		);
		const { getValues } = this.props;
		return _.isFunction(getValues) ? getValues(values) : values;
	}

	setValue(id, value) {
		const input = this.inputs[id];
		if (!input || !input.isEnable()) return this;
		input.setValue(value);
		return this;
	}
	setValues(values) {
		_.keys(values).map(key => this.setValue(key, values[key]));
		return this;
	}

	getInput(id) {
		return this.inputs[id];
	}

	lock() {
		this.lockedInputs = _.filter(this.inputs, input =>
			input &&
				(!input.isView || (_.isFunction(input.isView) && !input.isView())) &&
				input.isEnable() && input.isEditable() ?
				(input.readOnly() || true) : false
		);
		return this;
	}
	unlock() {
		if (this.lockedInputs) this.lockedInputs.forEach(input => input.editable());
		delete this['lockedInputs'];
		return this;
	}
}

class Box extends Forming {
	static version = '1.0.3';
	static propTypes = {
		//stick: PropTypes.node,
		stickDirection: PropTypes.oneOf(['inside', 'auto', 'ver', 'hor', 'top', 'bottom', 'left', 'right']),
		stickAlign: PropTypes.number,
		stickOffset: PropTypes.object,
		theme: PropTypes.string,
		style: PropTypes.object,
		modal: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		level: PropTypes.number,
		closeByESC: PropTypes.bool,
		closeByClickBox: PropTypes.bool,
		closeByClickDocument: PropTypes.bool,
		close: PropTypes.func,
		//inject: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
		openFx: PropTypes.string,
		isEventControl: PropTypes.bool,
		eventLevel: PropTypes.number,
		pointer: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom', 'left', 'right'])]),
		pointerClassName: PropTypes.string,
		pointerStyle: PropTypes.object,
	};
	static defaultProps = {
		stick: document.body,
		stickDirection: 'inside',
		stickAlign: 0,
		stickOffset: null,
		modal: false,
		level: 1,
		closeByESC: true,
		closeByClickBox: false,
		closeByClickDocument: true,
		clickExcludes: null,
		inject: document.body,
		openFx: null,
		eventLevel: 0,
		pointer: false,
		isEventControl: false,
		listenResize: true,
	};
	static clickEventQueue = [];
	static keyupEventQueue = [];
	static eventLevels = {};
	static contextType = MobileContext;
	_props = {};

	constructor(props) {
		super(props);
		this._clickEvent = this._clickEvent.bind(this);
		this._keyupEvent = this._keyupEvent.bind(this);
		this._resizeEvent = this._resizeEvent.bind(this);
		const { close, listenResize, isEventControl, eventLevel } = this.props;
		if (!_.isFunction(close)) {
			H2.devError({ msg: `${this.constructor.name} 需要的 props: "close" 啦，不然無法關閉` });
			this._props.close = () => { };
		}
		document.addEventListener('click', this._clickEvent);
		document.addEventListener('keyup', this._keyupEvent);
		if (listenResize) window.addEventListener('resize', this._resizeEvent);

		if (isEventControl) {
			this.eventLevel = eventLevel;
			if (Box.eventLevels[eventLevel]) Box.eventLevels[eventLevel]._close();
			Box.eventLevels[eventLevel] = this;
		}

		if (_.isString(this.props.pointer)) this.state.pointerDirection = this.props.pointer;
	}

	componentDidMount() {
		super.componentDidMount();
		this.position();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		//this.position();
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		const { isEventControl, eventLevel } = this.props;
		setTimeout(() => {
			document.removeEventListener('click', this._clickEvent);
			document.removeEventListener('keyup', this._keyupEvent);
			window.removeEventListener('resize', this._resizeEvent);
			if (isEventControl && Box.eventLevels[eventLevel] === this) delete Box.eventLevels[eventLevel];
		}, 0);
	}

	getEventLevel() {
		return this.props.eventLevel;
	}

	_close(evt) {
		const { close, isEventControl, eventLevel } = this.props;
		if (_.isFunction(close)) close(evt);
		// 			close(() => {
		// 				document.removeEventListener('click', this._clickEvent);
		// 				document.removeEventListener('keyup', this._keyupEvent);
		// 				window.removeEventListener('resize', this._resizeEvent);
		// 				if(isEventControl && Box.eventLevels[eventLevel] === this) delete Box.eventLevels[eventLevel];
		// 			});
	}

	_clickEvent(evt) {
		const { isEventControl, eventLevel, inject } = this.props;
		if (isEventControl) {
			const maxEventLevel = +(_.max(_.keys(Box.eventLevels)) || 0);
			if (eventLevel < maxEventLevel) return;
		}

		const { closeByClickBox, closeByClickDocument, clickExcludes } = this.props;
		const { box, wrapper } = this._dom;
		const excludes = !clickExcludes ? [] : _.isArray(clickExcludes) ? clickExcludes : [clickExcludes];
		const target = evt.target;
		const _isContains = regions =>
			target.getProperty('_belong') || _.some(evt.composedPath(), t => _.some(regions, e => e === t));

		if (closeByClickBox && (!inject && !box || _isContains([wrapper]) && !_isContains(excludes)))
			return this._close(evt);
		if (closeByClickDocument && (!inject && !box || !_isContains([wrapper]) && !_isContains(excludes)))
			return this._close(evt);
	}
	_keyupEvent(evt) {
		const { closeByESC } = this.props;
		const key = evt.key;
		if (closeByESC && key === 'Escape') {
			const { isEventControl, eventLevel } = this.props;
			if (isEventControl) {
				const maxEventLevel = +(_.max(_.keys(Box.eventLevels)) || 0);
				if (eventLevel < maxEventLevel) return;
			}
			this._close(evt);
		}
	}
	_resizeEvent(evt) {
		this.forceUpdate(() => this.position());
	}

	position() {
		const { stick, stickAlign: align, stickOffset: offset, stickDirection: dir, pointer, width } = this.props;
		const { wrapper: dom } = this._dom;

		if (stick && dom) {
			const _getDirectionSpace = src => {
				const winSize = window.getSize();
				const coor = src.getCoordinates();
				const docScroll = document.getScroll();
				return {
					top: coor.top - docScroll.y,
					right: docScroll.x + winSize.x - coor.left - coor.width,
					bottom: docScroll.y + winSize.y - coor.top - coor.height,
					left: coor.left - docScroll.x
				};
			};
			const { top, bottom, right, left } = _getDirectionSpace(stick);

			const _transfer = (dir) => {
				if (dir === 'inside') return { position: 'center', edge: 'center' };

				let posX, posY, edgeX, edgeY;
				if (dir === 'auto') dir = top + bottom >= left + right ? 'ver' : 'hor';
				if (dir === 'ver') {
					posX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					posY = top > bottom ? 'top' : 'bottom';
					edgeX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					edgeY = top > bottom ? 'bottom' : 'top';
				}
				else if (dir === 'hor') {
					posX = left > right ? 'left' : 'right';
					posY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
					edgeX = left > right ? 'right' : 'left';
					edgeY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
				}
				else if (dir === 'top') {
					posX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					posY = 'top';
					edgeX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					edgeY = 'bottom';
				}
				else if (dir === 'bottom') {
					posX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					posY = 'bottom';
					edgeX = align === 0 ? 'center' : align > 0 ? 'right' : 'left';
					edgeY = 'top';
				}
				else if (dir === 'left') {
					posX = 'left';
					posY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
					edgeX = 'right';
					edgeY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
				}
				else if (dir === 'right') {
					posX = 'right';
					posY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
					edgeX = 'left';
					edgeY = align === 0 ? 'center' : align > 0 ? 'bottom' : 'top';
				}
				return {
					position: { x: posX, y: posY },
					edge: { x: edgeX, y: edgeY },
				};
			};
			const pos = _transfer(dir);
			const D = 8;
			const PX = { x: D }, NX = { x: -D }, PY = { y: D }, NY = { y: -D };
			const calOffset =
				dir === 'hor' || (dir === 'auto' && (top + bottom) < (left + right)) ? (left > right ? NX : PX) :
					dir === 'ver' || (dir === 'auto' && (top + bottom) >= (left + right)) ? (top > bottom ? NY : PY) :
						dir === 'top' ? NY :
							dir === 'bottom' ? PY :
								dir === 'left' ? NX :
									dir === 'right' ? PX : null;
			dom.position({
				relativeTo: stick,
				...pos,
				allowNegative: false,
				maximum: { x: document.body.getSize().x - dom.getSize().x - 8 },
				offset: {
					x: 0, y: 0,
					...pointer ? calOffset : null,
					...offset,
				},
			});

			if (pointer === true) {
				const d =
					dir === 'hor' || (dir === 'auto' && (top + bottom) < (left + right)) ? (left > right ? 'right' : 'left') :
						dir === 'ver' || (dir === 'auto' && (top + bottom) >= (left + right)) ? (top > bottom ? 'bottom' : 'top') :
							dir === 'top' ? 'bottom' :
								dir === 'bottom' ? 'top' :
									dir === 'left' ? 'right' :
										dir === 'right' ? 'left' : null;
				this.setState({ pointerDirection: d });
				// if(this._dom.pointer)
				// 	this._dom.pointer.position({
				// 		relativeTo: dom,
				// 		... _transfer(d),
				// 		allowNegative: true,
				// 	});
			}
		}
	}

	renderConfirm() { }
	renderBoxBody() {
		return this.renderBody();
	}
	renderBody() {
		const { renderBody: body, children } = this.props;
		return body ? (_.isFunction(body) ? body() : body) : children;
	}
	renderExtra() { }

	render() {
		const { className, theme, width, height, level, modal, style, openFx, inject, wrapperStyle, isRDate } = {
			... this.props,
			... this._props,
		};
		let currentWidth = _calWidth(width)?.width;
		let isOverWidth = getOverWidth(currentWidth);

		const _renderPointer = () => {
			const { pointerClassName: css, pointerStyle: s } = this.props;
			const { pointerDirection } = this.state;
			return pointerDirection ? <span {... {
				ref: ele => this._dom.pointer = ele,
				className: `pointer-${pointerDirection}` + (css ? ` ${css}` : ''),
				...s ? { style: s } : null
			}} /> : null;
		};

		const box = <>
			<div {... {
				ref: ele => this._dom.box = ele,
				className: (() => {
					let css = 'H2-Box';
					css += modal ? ` modal${this.context ? ' -mobile' : ''}` : '';
					css += _.isString(modal) ? ` ${modal}` : '';
					css += theme ? ` ${theme}` : '';
					return css;
				})(), style,
			}}>
				{
					!isOverWidth ? (
						<MobileContext.Consumer>
							{(isMobile) => {
								return (
									<div {... {
										ref: ele => this._dom.wrapper = ele,
										className: `-wrapper ${openFx ? openFx : ''}${isMobile ? '-mobile' : ''} ${className ? className : ''}`,
										style: {
											...width ? _calWidth(width) : null,
											...height ? _calLength(height, 'height') : null,
											...level > 1 ? { zIndex: level + 100 } : null,
											...wrapperStyle,
										}
									}}>{this.renderBoxBody()}{_renderPointer()}</div>
								);
							}}
						</MobileContext.Consumer>
					) : (
						<div {... {
							className: `-wrapper ${openFx ? openFx : ''} ${className ? className : ''}`,
							style: {
								width: '98vw',
								...height ? _calLength(height, 'height') : null,
								...level > 1 ? { zIndex: level + 100 } : null,
								...wrapperStyle,
							}
						}}>
							{this.renderBoxBody()}{_renderPointer()}
							<div {...{
								style: {
									display: 'none'
								},
								ref: ele => this._dom.wrapper = ele,
							}}></div>
						</div>
					)
				}
				{this.renderExtra()}
			</div>
			{this.renderConfirm()}
		</>;
		return inject ? ReactDOM.createPortal(box, inject) : box;
	}
}

export {
	Box, Forming
};
